import { useState, useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Button,
} from "@mui/material";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import { Colors } from "../../../../Styles/Colors";
import { ToolsFieldWithMic } from "../../../../Components/Common Components/CommonComponents";
import { renderTitle } from "../Common/DocCommonComponent";

const DocGeneralAdvice = (props) => {
  const [state, setState] = useState({
    adviceText: "",
    adviceId: null,
    postLoading: false,
  });

   const editorRef = useRef(null);

  const updateState = (data) => setState((prev) => ({ ...prev, ...data }));

   const setEditorContent = (html) => {
    try {
      if (
        editorRef.current &&
        editorRef.current.editorRef &&
        editorRef.current.editorRef.current
      ) {
        editorRef.current.editorRef.current.innerHTML = html || "";
      }
    } catch (err) {
      console.warn("Editor content update failed:", err);
    }
  };
  /** -------------------- GET API -------------------- **/
  const getGeneralAdvice = async () => {
    try {
      const { appointmentId, ipAdmissionId, clinicId, doctorId, isFromIp } = props;
      if (!isFromIp && !appointmentId) return;
      if (isFromIp && !ipAdmissionId) return;

      const params = isFromIp ? `?ip_admission_id=${ipAdmissionId}&clinic_id=${clinicId}&doctor_id=${doctorId}` : `?appointment_id=${appointmentId}`;
      const url = `${Serviceurls.AYURVEDA_GENERAL_ADVICE}${params}`;
      const res = await RestAPIService.getAll(url);

      if (res?.data?.status === "success") {
        const list = res.data.data || [];
          updateState({
            adviceText: list.general_advice
          });
          setEditorContent(list.general_advice);
      } else {
        props.errorMessage(res?.data?.message || "Failed to fetch General Advice");
      }
    } catch (e) {
      props.errorMessage(e.message || "Error fetching General Advice");
    }
  };

  /** -------------------- POST API -------------------- **/
  const postGeneralAdvice = async () => {
    try {
      const { appointmentId, patientId, ipAdmissionId, clinicId, doctorId, isFromIp } = props;
      if (!isFromIp && !appointmentId) return props.errorMessage("Appointment ID not found");
      if (isFromIp && !ipAdmissionId) return props.errorMessage("IP Admission ID not found");
      if(!state.adviceText.trim()) return props.errorMessage("General Advice cannot be empty")
      const payload = {
        general_advice: state.adviceText,
        patient_id: patientId
      };
      if (isFromIp) {
        payload.ip_admission_id = ipAdmissionId;
        payload.clinic_id = clinicId;
        payload.doctor_id = doctorId;
      } else {
        payload.appointment_id = appointmentId;
      }

      updateState({ postLoading: true });

      const res = await RestAPIService.create(payload, Serviceurls.AYURVEDA_GENERAL_ADVICE);

      if (res?.data?.status === "success") {
        props.successMessage(res.data.message || "General Advice saved successfully");
        getGeneralAdvice();
      } else {
        props.errorMessage(res?.data?.message || "Failed to save General Advice");
      }
    } catch (e) {
      props.errorMessage(e?.response?.data?.message || e.message);
    } finally {
      updateState({ postLoading: false });
    }
  };

  /** -------------------- CLEAR -------------------- **/
  const onClear = () => {
    updateState({ adviceText: "" });
    setEditorContent(""); // ✅ clear editor view
  };

   const handleEditorSave = (...args) => {
    let content = "";
    if (args.length === 1) {
      content = args[0] || "";
    } else if (args.length >= 2) {
      content = args[1] || "";
    }

    updateState({ adviceText: content });
  };

  /** -------------------- EFFECT -------------------- **/
  useEffect(() => {
    getGeneralAdvice();
  }, [props.appointmentId, props.isFromIp, props.ipAdmissionId]);

    useEffect(() => {
    props.registerRefreshFunction("general_advice", getGeneralAdvice);
  }, []);

  return (
    <Card
      sx={{
        width: "100%",
        height: "fit-content",
        padding: "0.8vw",
        border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`,
        marginBottom: "0.5vw",
      }}
    >
      <CardContent>
        {renderTitle("General Advice", props.isSelected)}
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Rich Text Editor / Textarea */}
          <ToolsFieldWithMic
            ref={editorRef}
            Title={""}
            EditorRef={editorRef}
            saveData={handleEditorSave}
            isFrom="GeneralAdvice"
            minHeight={"15vh"}
            overallHeight={"auto"}
            stateName="adviceText"
          />

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 1,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              onClick={onClear}
              disabled={state.postLoading}
            >
              CLEAR
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: Colors.themeDark,
                "&:hover": { backgroundColor: Colors.themePrimary },
              }}
              disabled={state.postLoading}
              onClick={postGeneralAdvice}
            >
              SAVE
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DocGeneralAdvice;